module.exports = __webpack_public_path__ + "img/travel.07bd8fe4.svg";